import React, {useEffect, useMemo} from 'react';
import {useTable, usePagination, useFilters, useRowSelect} from 'react-table';
import {Cell} from './cell';

export const useTableAudit = ({
  columnsTable,
  dataTable,
  updateTable,
  FloatingInventoryAuditFilter,
  resetAllFilters,
  setResetAllFilters,
}) => {
  const data = useMemo(() => dataTable, [dataTable]);
  const columns = useMemo(() => columnsTable, [columnsTable]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setAllFilters,
    filteredRows,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': FloatingInventoryAuditFilter},
      'initialState': {'pageIndex': 0, 'pageSize': 20},
      'autoResetFilters': true,
    },
    useFilters,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns, i) => [
        ...columns.map((column, i) => {
          return {
            ...column,
            'title': 'selectionColumn',
            'Cell': ({row, column, value, ...rest}) => {
              return <Cell row={row} column={column} />;
            },
          };
        }),
      ]);
    }
  );

  useEffect(() => {
    if (resetAllFilters) {
      setAllFilters([]);
      setResetAllFilters(false);
    }
  }, [resetAllFilters]);
  
  return {
    'actions': {
      'useTableValues': {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        filteredRows,
        setAllFilters,
        'state': {pageIndex, pageSize},
      },
    },
  };
};
